// Phase 81vv — Quick Stats Row 4 cards cho homepage VĐV
import { TrendUp, MapTrifold, ChartPieSlice, Trophy } from "@phosphor-icons/react";

const STAT_CONFIG = [
  {
    key: "points",
    icon: TrendUp,
    iconColor: "#FF8A00",
    bg: "bg-[#FF8A00]/10",
    border: "border-[#FF8A00]/35",
    valueColor: "text-[#FF8A00]",
    label: "Điểm hiện tại",
  },
  {
    key: "rank",
    icon: MapTrifold,
    iconColor: "#A8FF00",
    bg: "bg-[#A8FF00]/10",
    border: "border-white/8",
    valueColor: "text-[#A8FF00]",
    label: "Khu vực",
    // Phase 84.M.22 — `rank` ships as a pre-formatted STRING "Top N/Total".
    // We no longer prefix "Top " here. The card label is overridden per-render
    // when `stats.rankLabel` (province name) is provided.
    dynamicLabelKey: "rankLabel",
  },
  {
    key: "winrate",
    icon: ChartPieSlice,
    iconColor: "#9D4CDD",
    bg: "bg-[#9D4CDD]/10",
    border: "border-white/8",
    valueColor: "text-[#C084FC]",
    label: "Winrate",
    suffix: "%",
  },
  {
    key: "tournaments",
    icon: Trophy,
    iconColor: "#007AFF",
    bg: "bg-[#007AFF]/10",
    border: "border-white/8",
    valueColor: "text-[#60A5FA]",
    label: "Giải tham gia",
  },
];

export default function QuickStats({ stats }) {
  return (
    <div className="px-5 pt-2" data-testid="home-quick-stats">
      <div className="grid grid-cols-4 gap-2.5">
        {STAT_CONFIG.map((cfg) => {
          const Icon = cfg.icon;
          const raw = stats?.[cfg.key];
          const value =
            typeof raw === "number"
              ? raw.toLocaleString("vi-VN", { minimumFractionDigits: 0, maximumFractionDigits: 3 })
              : raw ?? "—";
          // Phase 84.M.22 — Some cards (vd `rank`) override their label with
          // a dynamic value (province name from `stats.rankLabel`).
          const label = cfg.dynamicLabelKey && stats?.[cfg.dynamicLabelKey]
            ? stats[cfg.dynamicLabelKey]
            : cfg.label;
          return (
            <div
              key={cfg.key}
              className={`relative rounded-[18px] border ${cfg.border} ${cfg.bg} backdrop-blur-xl p-3 sm:p-4 flex flex-col justify-between min-h-[110px]`}
              data-testid={`home-stat-${cfg.key}`}
            >
              <div className="flex items-center justify-between">
                <Icon size={18} weight="bold" style={{ color: cfg.iconColor }} />
              </div>
              <div className="mt-2">
                <div
                  className={`text-[18px] sm:text-[22px] font-black tabular-nums ${cfg.valueColor} leading-none`}
                  data-testid={`home-stat-${cfg.key}-value`}
                >
                  {cfg.prefix || ""}
                  {value}
                  {cfg.suffix || ""}
                </div>
                <div className="text-[10.5px] sm:text-[11px] text-[#94A3B8] mt-1.5 font-medium leading-tight">
                  {label}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
